export default "__VITE_ASSET__E5MS5cqo__"